export class ProductCode {
  public static NonRenewing = ['NonRenew'];
}
